import Vue from "vue";
import Router from "vue-router";
import routerView from "../basicParts/router-view.vue";
import menu from "../components/menu.vue";
// import realTime from '../components/realTime.vue'

const Auth = () => import("../components/Auth.vue");
const realTime = () =>
  import(/* webpackChunkName: 'realTime' */ "../components/realTime.vue");
const realTimeDetail = () =>
  import(
    /* webpackChunkName: 'realTimeDetail' */ "../components/realTimeDetail.vue"
  );
const ceBao123 = () =>
  import(
    /* webpackChunkName: 'ceBao123' */ "../components/ceBao123/ceBao123.vue"
  );
const ceBao123Detail = () =>
  import(
    /* webpackChunkName: 'ceBao123Detail' */ "../components/ceBao123/ceBao123Detail.vue"
  );
const batteryDetail = () =>
  import(
    /* webpackChunkName: 'batteryDetail' */ "../components/batteryDetail.vue"
  );
// import index from '../basicParts/isLogin.vue'
const index = () => import("../basicParts/isLogin.vue");
const loginJump = () => import("../basicParts/loginJump.vue");
const userJudge = () => import("../basicParts/userJudge.vue");

// import login from '../components/loginUI.vue'
const login = () => import("../components/loginUI.vue");
const map = () =>
  import(/* webpackChunkName: 'map' */ "../components/map/map.vue");
const trapperMap = () =>
  import(/* webpackChunkName: 'trapperMap' */ "../components/trapperMap.vue");
const compare = () =>
  import(/* webpackChunkName: 'compare' */ "../components/compare/compare.vue");

const InsectInfo = () => import("../components/insectRepo.vue");
const DetectPoint = () => import("../components/detectPoint/detectPoint.vue");
const Equipment = () =>
  import(
    /* webpackChunkName: 'equipment' */ "../components/equipment/equipment.vue"
  );
const Settings = () => import("../components/setting.vue");
const forecast = () => import("../components/forecast.vue");
const region = () => import("../components/regionCompare.vue");
const InformationExport = () =>
  import("../components/Overview/InformationExport.vue");
const Repair = () => import("../components/repair.vue");
const WorkOrder = () => import("../components/workOrder.vue");
const Auditor = () => import("../components/auditor/auditor.vue");
const WorkOrderDetail = () => import("../components/workOrderDetail.vue");
const Material = () => import("../components/material.vue");
const neighborArea = () =>
  import("../components/neighborArea/neighborArea.vue");
const regionalManage = () =>
  import("../components/regionalManage/regionalManage.vue");
const CropArea = () => import("../components/CropArea/CropArea.vue");
const Template = () => import("../components/Information/Template.vue");
const weatherStation = () =>
  import("../components/weatherStation/weatherStation.vue");

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main/region",
      component: index,
      children: [
        {
          path: "main",
          component: menu,
          redirect: "/main/region",
          children: [
            { path: "region", name: "region", component: region },
            { path: "realTime", name: "realTime", component: realTime },
            {
              path: "realTime/realTimeDetail",
              name: "realTimeDetail",
              component: realTimeDetail,
            },
            { path: "ceBao123", name: "ceBao123", component: ceBao123 },
            {
              path: "ceBao123/ceBao123Detail",
              name: "ceBao123Detail",
              component: ceBao123Detail,
            },
            {
              path: "batteryDetail/:tid",
              name: "battery",
              component: batteryDetail,
            },
            { path: "map", component: map },
            {
              path: "mapNew",
              component: () => import("../basicParts/mapNew.vue"),
            },
            { path: "trapperMap", component: trapperMap },
            { path: "compare", component: compare },
            { path: "insectRepo", component: InsectInfo },
            { path: "detectPoints", component: DetectPoint },
            { path: "equipment", component: Equipment },
            { path: "setting", component: Settings },
            { path: "forecast", component: forecast },
            { path: "repair", component: Repair },
            { path: "workOrder", name: "workOrder", component: WorkOrder },
            { path: "auditor", name: "auditor", component: Auditor },
            {
              path: "workOrder/detail",
              name: "workOrderDetail",
              component: WorkOrderDetail,
            },
            { path: "material", component: Material },
            { path: "neighborArea", component: neighborArea },
            { path: "regionalManage", component: regionalManage },
            { path: "cropArea", component: CropArea },
            { path: "information/template", component: Template },
            { path: "weatherStation", component: weatherStation },
          ],
        },
      ],
    },
    {
      path: "/overview/informationExport",
      name: "OverviewInformationExport",
      component: InformationExport,
    },
    {
      path: "/auth",
      name: "auth",
      component: Auth,
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/loginJump",
      name: "loginJump",
      component: loginJump,
    },
    {
      path: "/userJudge",
      name: "userJudge",
      component: userJudge,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js